// Buffer global shim — CRA 5 (webpack 5) stopped auto-polyfilling Node
// globals. @react-pdf/layout references the Buffer GLOBAL at image-fetch
// time (lib/index.js, fetchImage): without this shim that reference throws
// ReferenceError, the catch block warns "Buffer is not defined", and —
// the real cost — node.image.key is never assigned, so the renderer's
// image-dedup cache misses and every drawn logo is re-embedded into the
// PDF per page. The shim also stops that catch from hiding genuine image
// failures behind identical noise.
//
// Must be imported FIRST in src/index.js, before any component code.
import { Buffer } from "buffer";

if (typeof window !== "undefined" && typeof window.Buffer === "undefined") {
  window.Buffer = Buffer;
}
